import { Button, Container, Heading, Link, Text, TextField } from "@radix-ui/themes";
import useFetch from "../../core/hooks/useFetch";
import SubjectRightsService from "../../core/services/SubjectRightsService";
import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
export default function ActionsSubjectRights() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [id, setId] = useState<string | number | null>(searchParams.get('id'))
    const [name, setName] = useState<string>('')
    const [fetchAddSubjectRights, isLoading, error, errors] = useFetch(async () => {
        if(id) {
            await SubjectRightsService.Update(id, name)
            toast.success("Субъект права успешно сохранен!")
        }
        else {
            await SubjectRightsService.Add(name)
            toast.success("Субъект права успешно добавлен!")  
        }
         
    })
    const [fetchGetSubjectRights, isLoadingFetchGetSubjectRights, errorFetchGetSubjectRights, errorsFetchGetSubjectRights] = useFetch(async () => {
        if(id) {
        const data = await SubjectRightsService.Get(id)
        setName(data.name)
        }
    })
    useEffect(() => {
        fetchGetSubjectRights()
    }, [id])
    useEffect(() => {
        if (error) toast.error(error)
    }, [error])
    return (
        <Container className="wrapper pt-10">
            <ToastContainer />
            <Container className="shadow-xl p-10"> 
            <Link href="#" className="!flex !items-center" onClick={() => navigate(-1)}><ArrowLeftIcon /> Назад</Link>
            <Heading>
                {id ? "Рекдатирование" : "Новый"} Субъект права
            </Heading>
            <Container className="form mb-5">
                <Text>Название</Text>
                <TextField.Root placeholder="Тип субъекта права" value={name} onChange={e => setName(e.currentTarget.value)}>
                </TextField.Root>
            </Container>
            <Button variant="solid" color='grass' loading={isLoading} onClick={async () => await fetchAddSubjectRights()}>Сохранить</Button>
            </Container>
        </Container>
    )
}